module.exports = __webpack_public_path__ + "img/search-2-line.f1feaa5e.svg";